module.exports = __webpack_public_path__ + "static/return.3082311a.png";